<template>
  <div class="body-portal">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BodyPortal',
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  },
};
</script>
